import { render } from "./OTPModalControl.vue?vue&type=template&id=d5c1172a&scoped=true"
import script from "./OTPModalControl.vue?vue&type=script&lang=js"
export * from "./OTPModalControl.vue?vue&type=script&lang=js"

import "./OTPModalControl.vue?vue&type=style&index=0&id=d5c1172a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5c1172a"]])

export default __exports__